import { useEffect, useState } from "react";
import { STUDIO_CLOSURES_UPDATE } from "../components/announcements/StudioClosuresAnnouncementModal";

// The newest entry on the Updates page. Point this at the next update when
// one is added, and the sidebar highlight comes back for everyone.
export const LATEST_UPDATE = STUDIO_CLOSURES_UPDATE;

const VIEWED_EVENT = "dojotrack:latest-update-viewed";

function viewedKey(viewerId: string): string {
  return [
    "dojotrack",
    "update-viewed",
    LATEST_UPDATE.announcementId,
    LATEST_UPDATE.version,
    viewerId,
  ].join(":");
}

function hasViewedLatestUpdate(viewerId: string): boolean {
  try {
    return localStorage.getItem(viewedKey(viewerId)) === "true";
  } catch {
    // Without storage, don't keep nagging.
    return true;
  }
}

export function markLatestUpdateViewed(viewerId: string | null | undefined): void {
  if (!viewerId) return;
  try {
    localStorage.setItem(viewedKey(viewerId), "true");
  } catch {
    // Storage unavailable; the highlight simply stays.
  }
  window.dispatchEvent(new Event(VIEWED_EVENT));
}

// True while this viewer hasn't opened the latest update yet.
export function useHasUnseenUpdate(viewerId: string | null | undefined): boolean {
  const [unseen, setUnseen] = useState(false);

  useEffect(() => {
    if (!viewerId) {
      setUnseen(false);
      return;
    }
    const refresh = () => setUnseen(!hasViewedLatestUpdate(viewerId));
    refresh();
    window.addEventListener(VIEWED_EVENT, refresh);
    window.addEventListener("storage", refresh);
    return () => {
      window.removeEventListener(VIEWED_EVENT, refresh);
      window.removeEventListener("storage", refresh);
    };
  }, [viewerId]);

  return unseen;
}
